module.exports = __webpack_public_path__ + "static/DHCM4-0b02ebe94f0e76dff71b122b4011b57e.png";